import { useEffect, useState } from "react";

/**
 * Reactive breakpoint hook. Returns `true` whenever the viewport width is
 * below the given pixel threshold. Defaults to 768px (Tailwind's `md`).
 *
 * Used to swap layout primitives (side-by-side ↔ tabs, persistent sidebar ↔
 * drawer) without leaning on Tailwind's class-based responsiveness alone —
 * some of our layout decisions are stateful (sidebar open/closed) and can't
 * be expressed in CSS.
 */
export default function useIsMobile(breakpoint = 768) {
  const get = () => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < breakpoint;
  };
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    const onResize = () => setIsMobile(get());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}
